import React from 'react';
import Display from './parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../actions/siteActions';

class Feedback extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: true,
            open: false,
            thoughts: '',
            email: '',
            sent: false,
            message: false
        };

        this.open = this.open.bind(this);
        this.submit = this.submit.bind(this);
        this.close = this.close.bind(this);
        this.updateField = this.updateField.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.site.sentFeedback !== this.props.site.sentFeedback){
            setTimeout(()=>{
                if(this.state.open){
                    this.setState({
                        sent: true
                    });
                }
            }, 3000);
        }
    }
    submit(){
        this.props.actions.sendFeedback({
            input_values: {
                input_1: this.state.email,
                input_2: this.state.thoughts
            }
        });
    }
    close(){
        this.setState({
            visible: true,
            open: false
        });
    }
    open(){
        this.setState({
            visible: false,
            open: true
        });
    }
    updateField(e){
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    render() {
        return (
            <Display if={!this.state.sent}>
                <Display if={this.state.visible}>
                    <div className="beta-tag" onClick={this.open}>
                        Beta Version
                        <span>Click to give feedback</span>
                    </div>
                </Display>
                <Display if={this.state.open}>
                    <div className="form-wrapper">
                        <div className="beta-form">
                            <p>Please let us know what you think</p>
                            <textarea cols="7" placeholder="Your thoughts..." value={this.state.thoughts} name="thoughts" onChange={this.updateField} />
                            <input type="email" placeholder="Email address" name="email" value={this.state.email} onChange={this.updateField} />
                            <Display if={!this.props.site.sentFeedback}>
                                <Display if={!this.props.site.sendingFeedback}><div className="submit" onClick={this.submit}>Submit</div></Display>
                                <Display if={this.props.site.sendingFeedback}><div className="submit">Sending</div></Display>
                            </Display>
                            <Display if={this.props.site.sentFeedback}><p className="message">Thank you for your feedback!</p></Display>
                            <div className="close" onClick={this.close}></div>
                        </div>
                    </div>
                </Display>
            </Display>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);


/** WEBPACK FOOTER **
 ** ./src/js/components/feedback.js
 **/